import {
  IManagerSegmentQuestionDefinition,
  ManagerSegmentSelectionMode
} from './client';
import {
  ManagerSegment,
  ManagerSegmentAnswerValue,
  ManagerSegmentQuestion
} from './server';

const multipleQuestion = (
  question: ManagerSegmentQuestion,
  values: ManagerSegmentAnswerValue[]
): IManagerSegmentQuestionDefinition => ({
  question,
  selectionMode: ManagerSegmentSelectionMode.multiple,
  values,
  allowsOther: values.includes(ManagerSegmentAnswerValue.other)
});

export const MANAGER_SEGMENTS = Object.values(ManagerSegment);

export const MANAGER_SEGMENT_QUESTIONS: Record<
  ManagerSegment,
  IManagerSegmentQuestionDefinition[]
> = {
  [ManagerSegment.marketer]: [
    multipleQuestion(ManagerSegmentQuestion.marketerTasks, [
      ManagerSegmentAnswerValue.leadGenerationFunnels,
      ManagerSegmentAnswerValue.campaigns,
      ManagerSegmentAnswerValue.recurringCampaigns,
      ManagerSegmentAnswerValue.audienceSegmentation,
      ManagerSegmentAnswerValue.userDataCollection,
      ManagerSegmentAnswerValue.externalIntegrations,
      ManagerSegmentAnswerValue.other
    ])
  ],
  [ManagerSegment.customerSupport]: [
    {
      question: ManagerSegmentQuestion.supportTeam,
      selectionMode: ManagerSegmentSelectionMode.single,
      values: [
        ManagerSegmentAnswerValue.solo,
        ManagerSegmentAnswerValue.smallTeamUpToFive,
        ManagerSegmentAnswerValue.largerTeam
      ],
      allowsOther: false
    },
    multipleQuestion(ManagerSegmentQuestion.supportProcess, [
      ManagerSegmentAnswerValue.routing,
      ManagerSegmentAnswerValue.responseSla,
      ManagerSegmentAnswerValue.botsAndAiSupport,
      ManagerSegmentAnswerValue.answerInSmartbot,
      ManagerSegmentAnswerValue.answerInCrm,
      ManagerSegmentAnswerValue.answerInExternalHelpdesk,
      ManagerSegmentAnswerValue.other
    ]),
    multipleQuestion(ManagerSegmentQuestion.supportContactChannels, [
      ManagerSegmentAnswerValue.messengersAndSocial,
      ManagerSegmentAnswerValue.websiteWidget,
      ManagerSegmentAnswerValue.email
    ])
  ],
  [ManagerSegment.socialCommunity]: [
    multipleQuestion(ManagerSegmentQuestion.socialTasks, [
      ManagerSegmentAnswerValue.socialFaq,
      ManagerSegmentAnswerValue.communityActivities,
      ManagerSegmentAnswerValue.campaigns,
      ManagerSegmentAnswerValue.routeComplexRequests,
      ManagerSegmentAnswerValue.other
    ])
  ],
  [ManagerSegment.clientAutomation]: [
    multipleQuestion(ManagerSegmentQuestion.clientChannels, [
      ManagerSegmentAnswerValue.vk,
      ManagerSegmentAnswerValue.telegram,
      ManagerSegmentAnswerValue.max,
      ManagerSegmentAnswerValue.whatsapp,
      ManagerSegmentAnswerValue.jivo,
      ManagerSegmentAnswerValue.viber,
      ManagerSegmentAnswerValue.avito,
      ManagerSegmentAnswerValue.odnoklassniki,
      ManagerSegmentAnswerValue.websiteWidget
    ]),
    multipleQuestion(ManagerSegmentQuestion.clientIntegrations, [
      ManagerSegmentAnswerValue.crmIntegrations,
      ManagerSegmentAnswerValue.paymentIntegrations,
      ManagerSegmentAnswerValue.deliveryIntegrations,
      ManagerSegmentAnswerValue.telephonyIntegrations,
      ManagerSegmentAnswerValue.dataSourceIntegrations,
      ManagerSegmentAnswerValue.clientInternalSystemIntegrations
    ]),
    multipleQuestion(ManagerSegmentQuestion.clientScenarios, [
      ManagerSegmentAnswerValue.dialogScenarios,
      ManagerSegmentAnswerValue.branchingScenarios,
      ManagerSegmentAnswerValue.campaigns,
      ManagerSegmentAnswerValue.aiScenarios,
      ManagerSegmentAnswerValue.delayedActions,
      ManagerSegmentAnswerValue.other
    ]),
    multipleQuestion(ManagerSegmentQuestion.clientWorkFormat, [
      ManagerSegmentAnswerValue.multipleClientProjects,
      ManagerSegmentAnswerValue.workInClientCabinet
    ])
  ],
  [ManagerSegment.internalAutomation]: [
    multipleQuestion(ManagerSegmentQuestion.internalDepartments, [
      ManagerSegmentAnswerValue.automateHr,
      ManagerSegmentAnswerValue.automateSales,
      ManagerSegmentAnswerValue.automateMarketing,
      ManagerSegmentAnswerValue.automateSupport,
      ManagerSegmentAnswerValue.automateBackOffice,
      ManagerSegmentAnswerValue.automateFinance,
      ManagerSegmentAnswerValue.automateIt,
      ManagerSegmentAnswerValue.other
    ]),
    multipleQuestion(ManagerSegmentQuestion.internalAutomations, [
      ManagerSegmentAnswerValue.employeeNotifications,
      ManagerSegmentAnswerValue.employeeOnboarding,
      ManagerSegmentAnswerValue.internalSystemIntegrations
    ])
  ],
  [ManagerSegment.other]: [
    multipleQuestion(ManagerSegmentQuestion.generalTasks, [
      ManagerSegmentAnswerValue.leadGenerationFunnels,
      ManagerSegmentAnswerValue.campaigns,
      ManagerSegmentAnswerValue.audienceSegmentation,
      ManagerSegmentAnswerValue.userDataCollection,
      ManagerSegmentAnswerValue.answerCustomerRequests,
      ManagerSegmentAnswerValue.socialCommunityManagement,
      ManagerSegmentAnswerValue.communityActivities,
      ManagerSegmentAnswerValue.dialogScenarios,
      ManagerSegmentAnswerValue.aiScenarios,
      ManagerSegmentAnswerValue.externalIntegrations,
      ManagerSegmentAnswerValue.other
    ])
  ]
};

export const MANAGER_SEGMENT_OTHER_TEXT_MAX_LENGTH = 200;
